import * as constants from "@/constants";

export const setPlotPlanIdForMapping = (plotPlanId: number) => ({
  type: constants.PLOT_PLAN_MAPPING_SET_PLOT_PLAN_ID,
  payload: plotPlanId,
});
